// extracted by mini-css-extract-plugin
export default {"arrow":"style_arrow__2yUaA","backButton":"style_backButton__m597m"};